import {GitHubAvatar} from '@github-ui/github-avatar'
import type {PlanInfo} from '../../../types'

type Props = {
  planInfo: PlanInfo
  account?: string
}

export function AccountButtonAvatar({planInfo, account}: Props) {
  // Return the current user avatar if the current user is selected
  if (planInfo.currentUser && account === planInfo.currentUser.displayLogin && planInfo.currentUser.image) {
    return <GitHubAvatar src={planInfo.currentUser.image} size={20} data-testid="user-account-avatar" />
  }

  // Otherwise, find the matching organization
  const matchingOrg = planInfo.organizations.find(org => account === org.displayLogin && org.image)
  if (matchingOrg && matchingOrg.image) {
    return <GitHubAvatar square src={matchingOrg.image} size={20} data-testid="org-account-avatar" />
  }
  return null
}
